export default __webpack_public_path__ + "static/media/954.5baeb962.gif";